import { useTranslation } from 'react-i18next';
import { Steps } from 'ui';
import type { GiveStepsEnum } from '../types';

type P = {
  step: GiveStepsEnum;
};

const Stepper = ({ step }: P) => {
  const { t } = useTranslation();

  return <Steps current={step} items={[{ title: t('My giving options') }, { title: t('My giving summary') }]} />;
};

export default Stepper;
